const NAME_PREFIX = "pages.sellerProfile.storeInfo.options.";
const ROLE_PREFIX = "pages.sellerProfile.storeInfo.roles.";

function opt(id, slug, nameKey, extra = {}) {
    return {
        id,
        slug,
        nameKey: NAME_PREFIX + nameKey,
        ...extra,
    };
}

export const STORE_INFO_OPTIONS = {
    benefitTypes: [
        opt(1, "match-price", "benefitTypes.matchPrice"),
        opt(2, "loyalty", "benefitTypes.loyalty"),
        opt(3, "membership", "benefitTypes.membership"),
        opt(4, "extra-warranty", "benefitTypes.extraWarranty"),
    ],
};

export const STORE_INFO_CONTACT_ROLES = [
    {
        id: 1,
        slug: "ceo",
        payloadKey: "ceo",
        required: true,
        nameKey: ROLE_PREFIX + "ceo",
    },
    {
        id: 2,
        slug: "category_manager",
        payloadKey: "categoryManager",
        required: true,
        nameKey: ROLE_PREFIX + "categoryManager",
    },
    {
        id: 3,
        slug: "ecommerce_manager",
        payloadKey: "ecommerceManager",
        required: true,
        nameKey: ROLE_PREFIX + "ecommerceManager",
    },
    {
        id: 4,
        slug: "marketing_manager",
        payloadKey: "marketingManager",
        required: true,
        nameKey: ROLE_PREFIX + "marketingManager",
    },
    {
        id: 5,
        slug: "it_contact",
        payloadKey: "itContact",
        required: false,
        nameKey: ROLE_PREFIX + "itContact",
    },
];

export const STORE_INFO_CONTACT_FIELDS = ["name", "email", "phone"];

export function optionBySlug(options, slug) {
    return options.find((option) => option.slug === slug) ?? null;
}

export function optionSlugs(options) {
    return options.map((option) => option.slug);
}

export function requiredContactRoles() {
    return STORE_INFO_CONTACT_ROLES.filter((role) => role.required);
}

export function translatedCountryLabel(t, countryCode, fallback = "") {
    const code = String(countryCode || "").toLowerCase();
    if (!code) {
        return fallback;
    }

    const key = `pages.sellerProfile.storeInfo.countries.${code}`;
    const label = t(key);

    return label && label !== key ? label : fallback;
}
